import { Fragment, useEffect, useState } from "react";
import "./schedule_class.scss";
// Import react-circular-progressbar module and styles
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import moment from "moment";
import images from "../../../../../../utilities/images/images";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import {
  isEmpty,
  sliceString,
  splitString,
} from "../../../../../../custom_utilities/custom_useful_functions";
import {
  url_14,
  url_15_1,
  url_55,
  url_99,
  url_8,
} from "../../../../../../custom_utilities/api_services";
import * as rdd from "react-device-detect";

//Redux
import { connect } from "react-redux";
import uiActions from "../../../../../../redux/ui/action";
import userActivityActions from "../../../../../../redux/user_activity/action";

import { setLiveVideoStreamDetails } from "../../../../../../redux/live_video_streaming/LiveVideoStreamingSlice";
import { setHomeworkData } from "../../../../../../redux/homework/HomeWorkSlice";
import HomeWorkListHomePage from "../../../../user_exercise_test/user_homework/homework_data/homework_homepage/HomeWorkListHomePage";
const ScheduleClass = (props) => {
  let {
    history,
    userPreference,
    startLoading,
    finishLoading,
    setVideoData,
    setNotesData,
    setLiveStreamData,
    setRecordedVideoDataAction,
    token,
    tokenType,
    setLiveVideoStreamDetailsAction,
    setHomeworkDataAction,
    homeworkData,
    isPaid,
    userData,
    embeddedInMySpace = false,
  } = props;
  let { targetDetails, courseDetails, classDetails, batchDetails } =
    userPreference;

  const [userTestProgressDetails, setUserTestProgressDetails] = useState({});

  const [state, setState] = useState({
    selectedSchedule: {
      date: "",
      day: "",
    },
    scheduleTimeTable: {},
    scheduleData: {
      videos: [],
      notes: [],
      liveClasses: [],
      offline: [],
    },
    isPaid: null,
  });

  useEffect(() => {
    getScheduleTimeTable();
    if (!embeddedInMySpace) {
      getMyProgressDetails();
    }
    // getUserData();
  }, []);

  useEffect(() => {
    if (state.selectedSchedule.date) {
      getScheduleContent();
    }
  }, [state.selectedSchedule.date]);

  // const getUserData = async () => {
  //   try {
  //     const response = await axios.get(url_8);
  //     if (response.data.status === 200) {
  //       setState((prevState) => ({
  //         ...prevState,
  //         isPaid: response.data.data.is_paid,
  //       }));
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const getMyProgressDetails = async () => {
    const headers = {
      Authorization: `${tokenType} ${token}`,
    };

    const response = await axios.post(url_99, headers);
    if (response.data.status === 200) {
      setUserTestProgressDetails({ ...response.data.data });
    }
  };

  const getScheduleTimeTable = async () => {
    let data = {
      course_id: courseDetails[0].course_id,
      batch_id: batchDetails.batch_id,
    };

    try {
      let response = await axios.get(
        `${url_14}?course_id=${data.course_id}&batch_id=${data.batch_id}`
      );
      if (response.data.status === 200) {
        if (response.data.data.ScheduleWeek.length) {
          let returnedResponse = getTodayDateAndDay();
          setState((prevState) => ({
            ...prevState,
            scheduleTimeTable: response.data.data,
            selectedSchedule: {
              ...prevState.selectedSchedule,
              // date: response.data.data.ScheduleWeek[0].date,
              // day: response.data.data.ScheduleWeek[0].day,
              date: returnedResponse.date,
              day: returnedResponse.day,
            },
          }));
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getTodayDateAndDay = () => {
    let d = new Date();
    let date, month, year, day;
    let dayArr = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    date = d.getDate();
    month = d.getMonth();
    year = d.getFullYear();
    day = d.getDay();

    if (date < 10) {
      date = `0${date}`;
    }

    // if (month < 10) {
    //   month = `0${month + 1}`;
    // }
    if (month < 9) {
      month = `0${month + 1}`;
    } else {
      month = `${month + 1}`;
    }

    let data = {
      date: `${year}-${month}-${date}`,
      day: dayArr[day],
    };
    return data;
  };

  const handleChangeScheduleDate = (event, date, day) => {
    setState((prevState) => ({
      ...prevState,
      selectedSchedule: { ...prevState.selectedSchedule, date: date, day: day },
    }));
  };

  const getScheduleContent = async () => {
    let selectedSchedule = { ...state.selectedSchedule };
    let data = {
      course_id: courseDetails[0].course_id,
      batch_id: batchDetails.batch_id,
      day: selectedSchedule.day,
      date: selectedSchedule.date,
    };
    startLoading();
    try {
      const response = await axios.post(url_15_1, data);

      if (response.data.status === 200) {
        finishLoading();
        setState((prevState) => ({
          ...prevState,
          scheduleData: {
            ...prevState.scheduleData,
            videos: response.data.data.video,
            notes: response.data.data.notes,
            liveClasses: response.data.data.zoomclass,
            offline: response.data.data.offline,
          },
        }));

        setHomeworkDataAction(response.data.data.homework);
      }
    } catch (error) {
      console.log(error);
      finishLoading();
    }
  };

  const handleStoreVideoData = (videoData) => {
    if (!videoData.is_paid) {
      videoData.redirectedFrom = "schedule_class";
      setVideoData(videoData);
      history.push("/videos");
    } else {
      alert("You haven't purchased a plan. Please purchase it from store.");
      history.push("/store");
    }
  };

  const handleStoreNotesData = (notesData) => {
    if (notesData.is_paid) {
      notesData.redirectedFrom = "schedule_class";
      setNotesData(notesData);
      history.push("/notes");
    } else {
      alert("You haven't purchased a plan. Please purchase it from store.");
      history.push("/store");
    }
  };

  const isClassEnded = (element) => getLabel(element) === "ended";

  const canJoinLiveClass = (element) => {
    const isRecorded =
      element?.status_stream === "recorded" || Boolean(element?.rec_id);
    if (isRecorded) return true;
    return !isClassEnded(element);
  };

  const handleLiveClassClick = (element) => {
    const isRecorded =
      element?.status_stream === "recorded" || Boolean(element?.rec_id);

    if (isRecorded) {
      handleRecordedWatchNow(element);
      return;
    }

    if (isClassEnded(element)) {
      return;
    }

    setLiveClassRecord(element);
  };

  const setLiveClassRecord = async (element) => {
    if (isClassEnded(element)) {
      return;
    }

    if (isPaid === 0) {
      alert("You haven't purchased a plan. Please purchase it from store.");
      history.push("/store");
      return;
    }

    if (String(element.stream_service) === "3") {
      if (element.student_join_url) {
        window.location.assign(element.student_join_url);
      }
      return;
    }

    let zoomId = decrypt_functionality(element.zoom_id);
    let data = {
      device_id: rdd.fullBrowserVersion,
      device_type: rdd.browserName,
      device_name: rdd.osName,
      zoom_id: zoomId,
      type: "Web",
    };
    startLoading();
    try {
      const response = await axios.post(url_55, data);
      if (response.data.status === 200) {
        finishLoading();
        const streamPayload = {
          ...response.data.data,
          ...element,
          redirectedFrom: "schedule_class",
        };

        if (element.stream_service === "1") {
          handleStoreLiveStreamData(streamPayload);
        } else if (element.stream_service === "2") {
          setLiveVideoStreamDetailsAction({
            zoomId,
            isLive: true,
            live_class_id: element.id,
            normalVideos: false,
          });
          history.push({
            pathname: "/streaming",
            state: { zoomId: zoomId, isLive: true, live_class_id: element.id },
          });
        } else {
          alert("There was an error, Please try again later");
        }
      } else {
        finishLoading();
        alert(response.data.message);
      }
    } catch (error) {
      console.log(error);
      finishLoading();
    }
  };

  const handleRecordedWatchNow = async (element) => {
    if (isPaid === 0) {
      alert("You haven't purchased a plan. Please purchase it from store.");
      history.push("/store");
      return;
    }
    
    // Recorded player expects `rec_id` as the id.
    const recordedId =
      element?.rec_id ?? element?.recId ?? element?.id ?? element?.zoom_id;
    if (!recordedId) return;

    setRecordedVideoDataAction(element);
    history.push("/recorded");
  };

  const decrypt_functionality = (val) => {
    const CryptoJS = require("crypto-js");
    let encrypted = val;
    let key = "0CiuKpLCZbX7gBCyYTka4USxTnh7ssXKk8bJ6Y3TXPc=";
    encrypted = atob(encrypted);
    encrypted = JSON.parse(encrypted);
    const iv = CryptoJS.enc.Base64.parse(encrypted.iv);
    const value = encrypted.value;
    key = CryptoJS.enc.Base64.parse(key);
    var decrypted = CryptoJS.AES.decrypt(value, key, { iv: iv });
    decrypted = decrypted.toString(CryptoJS.enc.Utf8);
    return decrypted.split("*")[1];
  };

  const handleStoreLiveStreamData = (liveStreamData) => {
    liveStreamData.redirectedFrom = "schedule_class";
    setLiveStreamData(liveStreamData);
    history.push("/zoom");
  };

  const renderNoDataPlaceholder = (type) => {
    switch (type) {
      case "videos":
        return (
          <div
            className="no_data_found_wrapper"
            style={{ textAlign: "center" }}
          ></div>
        );

      default:
        return null;
    }
  };
  function getLabel({
    current_time: currentTime,
    start_time: startTime,
    meetdate,
    end_time: endTime,
    stream_service,
    status_stream,
    rec_id,
  }) {
    if (status_stream === "recorded" || rec_id) return "recorded";

    if (stream_service === "1") {
      currentTime = getMomentFromString(currentTime);
      startTime = getMomentFromString(startTime, meetdate);
      endTime = getMomentFromString(endTime, meetdate);
      let label = "";

      if (currentTime.isBefore(startTime)) label = "upcoming";
      else if (currentTime.isBetween(startTime, endTime)) label = "live";
      else if (currentTime.isAfter(endTime)) label = "ended";
      return label;
    } else if (stream_service === "2") {
      return status_stream;
    } else if (stream_service === "3") {
      return status_stream || "upcoming";
    }
  }

  function getMomentFromString(timeString, meetdate) {
    const date = meetdate ? moment(meetdate, "YYYY-MM-DD") : moment();
    const [hour, minute, second = "0"] = timeString.split(":");
    return date.set({ hour, minute, second });
  }

  return (
    <Fragment>
      <div className="scheduleClass_wrapper">
        <div className="scheduleClass_inner_wrapper">
          <div className="scheduleClass_left">
            <h4>My Schedule</h4>
            <section
              className="sec_2_wrapper"
              style={{ margin: "10px 0px 20px" }}
            >
              <div className="date_time_collection">
                {!isEmpty(state.scheduleTimeTable)
                  ? state.scheduleTimeTable.ScheduleWeek.length
                    ? state.scheduleTimeTable.ScheduleWeek.map(
                        (element, index) => {
                          return (
                            <div key={index} className="single_select_date">
                              <input
                                type="radio"
                                id={element.date}
                                name="dateTime"
                                value={element.date}
                                onChange={(event) =>
                                  handleChangeScheduleDate(
                                    event,
                                    element.date,
                                    element.day
                                  )
                                }
                                checked={
                                  element.date === state.selectedSchedule.date
                                }
                              />

                              <label htmlFor={element.date}>
                                <div className="text_content_wrapper_1">
                                  <p className="text_content_1">
                                    {sliceString(element.day, 0, 3)}
                                  </p>
                                </div>
                                <div className="text_content_wrapper_2">
                                  <p className="text_content_2">
                                    {splitString(element.date, "end")}
                                  </p>
                                </div>
                              </label>
                            </div>
                          );
                        }
                      )
                    : null
                  : null}
              </div>
            </section>
            <div className="sec_3_wrapper">
              <div className="classes_collection">
                {/* //////////////////videos//////////////////////////////////////////// */}
                {state.scheduleData.videos.length
                  ? state.scheduleData.videos.map((element, index) => {
                      return (
                        <div
                          key={index}
                          className="single_class_wrapper"
                          onClick={() => handleStoreVideoData(element)}
                        >
                          <div className="left_side_container_wrapper">
                            <div className="image_wrapper">
                              <img src={element.video_thumnail} />
                            </div>
                          </div>
                          <div className="right_side_container_wrapper">
                            <div className="text_content_wrapper_1">
                              <p className="text_content_1">
                                {element.notes_title}
                              </p>
                            </div>
                            <div className="text_content_wrapper_2">
                              <p className="text_content_2">{`by ${element.by_upload}`}</p>
                            </div>
                            <div className="text_content_wrapper_2">
                              <p className="text_content_2">
                                {element.subject}
                              </p>
                            </div>
                            <div className="sub_content_wrapper">
                              <div className="left_side_container_wrapper">
                                <div className="text_content_wrapper">
                                  <p className="text_content">
                                    <img src={images.user_dashboard_3} />
                                    {`${element.start_time} - ${element.end_time}`}
                                  </p>
                                </div>
                              </div>
                              <div className="right_side_container_wrapper">
                                <span className="subject_name">Video</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  : renderNoDataPlaceholder("videos")}
                {/* ////////////////////////////notes/////////////////////////////// */}
                {state.scheduleData.notes.length
                  ? state.scheduleData.notes.map((element, index) => {
                      return (
                        <div
                          key={index}
                          className="single_class_wrapper"
                          onClick={() => handleStoreNotesData(element)}
                        >
                          <div className="left_side_container_wrapper">
                            <div className="image_wrapper">
                              <img src={element.video_thumnail} />
                            </div>
                          </div>
                          <div className="right_side_container_wrapper">
                            <div className="text_content_wrapper_1">
                              <p className="text_content_1">
                                {element.notes_title}
                              </p>
                            </div>
                            <div className="text_content_wrapper_2">
                              <p className="text_content_2">{`by ${element.by_upload}`}</p>
                            </div>
                            <div className="text_content_wrapper_2">
                              <p className="text_content_2">
                                {element.subject}
                              </p>
                            </div>
                            <div className="sub_content_wrapper">
                              <div className="left_side_container_wrapper">
                                <div className="text_content_wrapper">
                                  <p className="text_content">
                                    <img src={images.user_dashboard_3} />
                                    {`${element.start_time} - ${element.end_time}`}
                                  </p>
                                </div>
                              </div>
                              <div className="right_side_container_wrapper">
                                <span className="subject_name">Notes</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  : // renderNoDataPlaceholder("notes")}
                    null}

                <HomeWorkListHomePage />

                {/* ///////////////////////////live Classess/////////////////////////// */}

                {state.scheduleData.liveClasses.length
                  ? state.scheduleData.liveClasses.map((element, index) => {
                      const isRecorded =
                        element?.status_stream === "recorded" ||
                        Boolean(element?.rec_id);
                      const label = getLabel(element);
                      const isJoinable = canJoinLiveClass(element);
                      return (
                        <div
                          key={"live_class_" + index}
                          className={`single_class_wrapper${
                            !isJoinable ? " single_class_wrapper--disabled" : ""
                          }`}
                          onClick={() => handleLiveClassClick(element)}
                          role={isJoinable ? "button" : undefined}
                          tabIndex={isJoinable ? 0 : undefined}
                          onKeyDown={
                            isJoinable
                              ? (event) => {
                                  if (
                                    event.key === "Enter" ||
                                    event.key === " "
                                  ) {
                                    event.preventDefault();
                                    handleLiveClassClick(element);
                                  }
                                }
                              : undefined
                          }
                        >
                          <div className="left_side_container_wrapper">
                            <div className="image_wrapper">
                              <img src={element.faculty_image} />
                            </div>
                          </div>
                          <div className="right_side_container_wrapper">
                            <div className="text_content_wrapper_1">
                              <p className="text_content_1">
                                {element.description}
                              </p>
                            </div>
                            <div className="text_content_wrapper_2">
                              <p className="text_content_2 batchNm">
                                {element.subject}
                              </p>
                            </div>
                            <div className="text_content_wrapper_2">
                              <p className="text_content_2">{`by ${element.by_upload}`}</p>
                            </div>
                            <div className="sub_content_wrapper">
                              <div className="left_side_container_wrapper">
                                <div className="text_content_wrapper">
                                  <p className="text_content">
                                    <span>
                                      {isRecorded ? "" : "Join Live Class at:-"}
                                    </span>
                                    {`${moment(
                                      element.start_time,
                                      "HH:mm:ss"
                                    ).format("hh:mm A")} - ${moment(
                                      element.end_time,
                                      "HH:mm:ss"
                                    ).format("hh:mm A")}`}
                                  </p>
                                  <span className={`${label}`}>
                                    {label}
                                  </span>
                                  {isRecorded ? (
                                    <button
                                      type="button"
                                      className="watch_now_button"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleRecordedWatchNow(element);
                                      }}
                                    >
                                      Watch Now
                                    </button>
                                  ) : null}
                                </div>
                              </div>
                            </div>
                            {isJoinable ? (
                              <div className="arrow_dv">
                                <img src={images.right_Ar} alt="arrow" />
                              </div>
                            ) : null}
                          </div>
                        </div>
                      );
                    })
                  : // renderNoDataPlaceholder("live_class")
                    state?.scheduleData.offline.length == 0 &&
                    homeworkData.length == 0 && (
                      <div>
                        <div className="schedule_img">
                          <img src={images.new_folder_warning} alt="folder" />
                        </div>{" "}
                        <div className="schedule_text">
                          Currently there are no live classes or homework
                          available. we'll notify you once they are scheduled.
                        </div>
                      </div>
                    )}
                {/* ///////////////////////////Offline Classess/////////////////////////// */}

                {state.scheduleData.offline.length
                  ? state.scheduleData.offline.map((element, index) => {
                      return (
                        <div
                          key={"live_class_" + index}
                          className="single_class_wrapper"
                          // onClick={() => setLiveClassRecord(element)}
                        >
                          <div className="left_side_container_wrapper">
                            <div className="image_wrapper">
                              <img src={element.faculty_image} />
                            </div>
                          </div>
                          <div className="right_side_container_wrapper">
                            <div className="text_content_wrapper_1">
                              <p className="text_content_1">
                                {`Batch - ${element.batch_name} (${element.subject_name})`}
                              </p>
                            </div>
                            <div className="text_content_wrapper_2">
                              <p className="text_content_2 batchNm">
                                {`Topic - ${element.topic}`}
                              </p>
                            </div>
                            <div className="text_content_wrapper_2">
                              <p className="text_content_2">{`by ${element.faculty_name} at ${element.venue}`}</p>
                            </div>
                            <div className="sub_content_wrapper">
                              <div className="left_side_container_wrapper">
                                <div className="text_content_wrapper">
                                  <p className="text_content">
                                    <span>Offline Class,</span>
                                    {`${moment(
                                      element.start_time,
                                      "HH:mm:ss"
                                    ).format("hh:mm A")} - ${moment(
                                      element.end_time,
                                      "HH:mm:ss"
                                    ).format("hh:mm A")}`}
                                  </p>
                                  {(() => {
                                    const currentDate =
                                      moment().format("YYYY-MM-DD");
                                    const currentTime =
                                      moment().format("HH:mm:ss");

                                    if (element.date > currentDate) {
                                      // Class is scheduled for a future date
                                      return (
                                        <span className="upcoming">
                                          upcoming
                                        </span>
                                      );
                                    } else if (element.date < currentDate) {
                                      // Class date has passed
                                      return (
                                        <span className="ended">ended</span>
                                      );
                                    } else {
                                      // Class is scheduled for today, check time
                                      if (currentTime < element.start_time) {
                                        return (
                                          <span className="upcoming">
                                            upcoming
                                          </span>
                                        );
                                      } else if (
                                        currentTime >= element.start_time &&
                                        currentTime <= element.end_time
                                      ) {
                                        return (
                                          <span className="live">running</span>
                                        );
                                      } else {
                                        return (
                                          <span className="ended">ended</span>
                                        );
                                      }
                                    }
                                  })()}
                                </div>
                              </div>
                            </div>
                            <div className="arrow_dv"></div>
                          </div>
                        </div>
                      );
                    })
                  : null}
              </div>
            </div>
          </div>
          {!embeddedInMySpace ? (
          <div className="scheduleClass_right">
            <div className="home_page_my_progress">
              <h4>My Progress</h4>
              <div className="home_page_progress_box_wrapper">
                <div
                  className="home_page_progress_box"
                  style={{ cursor: "pointer" }}
                  onClick={() => history.push("/user_analytics")}
                >
                  <div className="home_page_progress-circle">
                    <div label="Default">
                      <CircularProgressbar
                        value={
                          userTestProgressDetails.user_total_test
                            ? userTestProgressDetails.user_total_test
                            : null
                        }
                        text={`${
                          userTestProgressDetails.user_total_test
                            ? userTestProgressDetails.user_total_percentage
                            : 0
                        }%`}
                        strokeWidth={6}
                        className="CircularProgressbarr"
                      />
                    </div>
                    <span className="score">Overall Score</span>
                  </div>
                  <div className="prgs_tst_detail">
                    <div className="tst_dtl_count">
                      <span className="tst_count">
                        {userTestProgressDetails
                          ? userTestProgressDetails.user_total_test
                          : null}
                      </span>
                      <span className="tst_name">Test Attempted</span>
                    </div>

                    <div className="tst_dtl_count">
                      <span className="tst_count">
                        {userTestProgressDetails
                          ? userTestProgressDetails.userdatacorrect
                          : null}
                      </span>
                      <span className="tst_name">Correct Answers</span>
                    </div>
                    <div className="tst_dtl_count">
                      <span className="tst_count">
                        {userTestProgressDetails
                          ? userTestProgressDetails.userdataincorrect
                          : null}{" "}
                      </span>
                      <span className="tst_name">Incorrect Answers</span>
                    </div>
                    <div className="tst_dtl_count">
                      <span className="tst_count">
                        {userTestProgressDetails
                          ? userTestProgressDetails.userdataunattempt
                          : null}{" "}
                      </span>
                      <span className="tst_name">Questions Skipped</span>
                    </div>
                    <div className="arrow_dv">
                      <Link
                        to={{
                          pathname: "/user_analytics",
                        }}
                      >
                        <img src={images.m2_rgtArow2} alt="arrow" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="home_page_test_list_wrapper">
              <h4>PYQ/TEST-SERIES</h4>
              <div className="test_list">
                <div className="test_1">
                  <Link
                    to={{
                      pathname: "/pyq",
                      state: { tab: "pyq" },
                    }}
                    style={{ textDecoration: "none" }}
                  >
                    <div className="test_name">
                      Previous Year Papers{" "}
                      <span>
                        <img src={images.m2_rgtArow1} alt="arrow" />
                      </span>
                    </div>
                  </Link>
                </div>

                <div className="test_2">
                  <Link
                    to={{
                      pathname: "/ots",
                      state: { tab: "ots" },
                    }}
                    style={{ textDecoration: "none" }}
                  >
                    <div className="test_name">
                      Test Series{" "}
                      <span>
                        <img src={images.m2_rgtArow1} alt="arrow" />
                      </span>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          ) : null}
        </div>
      </div>
      {/* </div> */}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    userPreference: state.userPreference,
    token: state.auth.authToken,
    tokenType: state.auth.tokenType,
    homeworkData: state.HomeWorkSlice.homeworkData,
    userData: state.auth.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    startLoading: () => {
      dispatch(uiActions.startLoading());
    },
    finishLoading: () => {
      dispatch(uiActions.finishLoading());
    },
    setVideoData: (payload) => {
      dispatch(userActivityActions.setVideoData(payload));
    },
    setNotesData: (payload) => {
      dispatch(userActivityActions.setNotesData(payload));
    },
    setLiveStreamData: (payload) => {
      dispatch(userActivityActions.setLiveStreamData(payload));
    },
      setRecordedVideoDataAction: (payload) => {
        dispatch(userActivityActions.setRecordedVideoData(payload));
      },

    setLiveVideoStreamDetailsAction: (payload) => {
      dispatch(setLiveVideoStreamDetails(payload));
    },

    setHomeworkDataAction: (payload) => {
      dispatch(setHomeworkData(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleClass);
